var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.993 1.4C13.993 0.63 13.37 0 12.6 0H1.4C0.63 0 0 0.63 0 1.4V9.8C0 10.57 0.63 11.2 1.4 11.2H11.2L14 14L13.993 1.4ZM10.5 8.4H3.5C3.115 8.4 2.8 8.085 2.8 7.7C2.8 7.315 3.115 7 3.5 7H10.5C10.885 7 11.2 7.315 11.2 7.7C11.2 8.085 10.885 8.4 10.5 8.4ZM10.5 6.3H3.5C3.115 6.3 2.8 5.985 2.8 5.6C2.8 5.215 3.115 4.9 3.5 4.9H10.5C10.885 4.9 11.2 5.215 11.2 5.6C11.2 5.985 10.885 6.3 10.5 6.3ZM10.5 4.2H3.5C3.115 4.2 2.8 3.885 2.8 3.5C2.8 3.115 3.115 2.8 3.5 2.8H10.5C10.885 2.8 11.2 3.115 11.2 3.5C11.2 3.885 10.885 4.2 10.5 4.2Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.14762168cc28d7d13e11580a3e795305.svg";
export { ForwardRef as ReactComponent };